<div class="overview__layout">
  <div class="overview__overview">
    <app-permissions-overview></app-permissions-overview>
  </div>
  <div class="overview__sidepanel">
    <app-permissions-sidepanel></app-permissions-sidepanel>
  </div>
</div>
